import { render, staticRenderFns } from "./electricityMeter.vue?vue&type=template&id=48afc41a&scoped=true&"
import script from "./electricityMeter.vue?vue&type=script&lang=js&"
export * from "./electricityMeter.vue?vue&type=script&lang=js&"
import style0 from "./electricityMeter.vue?vue&type=style&index=0&id=48afc41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afc41a",
  null
  
)

export default component.exports